@if (status()) {
  <div
    @enterFadeIn
    class="qaroni-title-status-chip min-w-24 text-center uppercase"
    [matTooltip]="matTooltipText()"
    [ngClass]="bgClassColorName()">
    {{ status() }}
  </div>
}
